var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "52px",
    viewBox: "0 0 42 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "apple") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.16250413 0.0431304348 6.95033686 0.0431304348 6.95033686 15.673113 0.16250413 15.673113"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "1.7122801e-09 0.139691696 41.7125885 0.139691696 41.7125885 39.3220339 1.7122801e-09 39.3220339"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04_proc_overview",
    transform: "translate(-474.000000, -433.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "apple",
    transform: "translate(474.000000, 431.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(16.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.678133333,18.3397797 C0.678133333,18.3397797 -2.18686667,7.93317101 5.5898,2.70951884 C5.5898,2.70951884 10.8521333,9.80030145 0.678133333,18.3397797",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.0000025,7 C10.0000025,7 9.96905894,14.5059891 16.8593117,16 C16.8593117,16 18.57815,9.70889292 10.0000025,7",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6481068,5.22075069 C18.6481068,5.22075069 29.1837,-2.45455285 36.5568356,1.06155193 C43.9296153,4.57801418 44.5674458,31.9686706 30.664022,37.4029757 C30.664022,37.4029757 26.5597678,37.0458601 24.6192254,35.5845103 C24.6192254,35.5845103 20.4690559,39.4123316 17.4582254,39.320461 C14.4473949,39.228233 -6.42589322,21.2008678 1.98229322,7.08675994 C1.98229322,7.08675994 7.3757339,0.601841602 18.6481068,5.22075069",
    id: "Fill-6",
    fill: "#B6B8C2",
    mask: "url(#mask-4)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.fd4ece1c4c21395ec5a14624b38179c2.svg";
export { ForwardRef as ReactComponent };